import { BsLayout } from './BsLayout';
export default BsLayout;
